"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Closed = exports.Suspended = exports.Connected = exports.Connecting = exports.NotConnected = exports.WebsocketGroup = void 0;
const state_flow_1 = require("@video/state-flow");
const gw_transport_1 = require("../transport/gw-transport");
const state_flow_2 = require("./state-flow");
//#endregion
//#region Group Declaration
// The group is responsible for the audio state management.
// If
exports.WebsocketGroup = state_flow_2.GwStateFlow.registerGroup("websocket").bootstrap(() => {
    return (0, exports.NotConnected)({
        uri: "",
        nextRetry: 0,
        attempt: 0,
        lastPing: 0,
        lastPong: 0,
        requestId: 0,
        requestPool: {},
        options: gw_transport_1.GwTransportOptions.parse({}),
    });
});
//#endregion
function nextRetry(options, attempt) {
    if (attempt >= options.maxRetries) {
        return -1;
    }
    return options.retryDelay.reduce((acc, [count, delay]) => {
        return attempt >= count ? delay : acc;
    }, 500);
}
//#region Signals Handlers
function options({ websocket }, signal) {
    return { ...websocket, options: { ...signal } };
}
function ready({ websocket }, signal) {
    return (0, exports.Connected)({
        ...websocket,
        nextRetry: 0,
        attempt: 0,
    });
}
function close({ websocket }) {
    return (0, exports.Closed)(websocket);
}
function closeWithRetry({ websocket }) {
    return (0, exports.Closed)({
        ...websocket,
        nextRetry: nextRetry(websocket.options, websocket.attempt),
        attempt: websocket.attempt + 1,
    });
}
function error({ websocket }, signal) {
    if (signal.reason === "sfu-busy") {
        return (0, exports.NotConnected)(websocket);
    }
    return (0, exports.Closed)({
        ...websocket,
        nextRetry: nextRetry(websocket.options, websocket.attempt),
        attempt: websocket.attempt + 1,
    });
}
function connect({ websocket }, signal) {
    return (0, exports.Connecting)({ ...websocket, uri: signal.uri });
}
function networkOnline({ websocket }, signal) {
    return (0, exports.Connecting)(websocket);
}
function networkOffline({ websocket }, signal) {
    return (0, exports.Suspended)({ ...websocket });
}
function ping({ websocket }, signal) {
    return { ...websocket, lastPing: Date.now() };
}
function pong({ websocket }, signal) {
    return { ...websocket, lastPong: Date.now() };
}
function messageSend({ websocket }, signal) {
    return {
        requestId: websocket.requestId + 1,
    };
}
function requestSend({ websocket }, signal) {
    const requestId = websocket.requestId + 1;
    return {
        requestId,
        requestPool: {
            ...websocket.requestPool,
            [requestId]: {
                resolve: signal.resolve,
                reject: signal.reject,
                type: signal.type,
                timestamp: Date.now(),
            },
        },
    };
}
function requestSendAuth(states, signal) {
    if (signal.type === "JWT") {
        return requestSend(states, signal);
    }
    return state_flow_1.Result.reject("Only JWT methods are allowed for auth while in the connecting state");
}
function responseReceive({ websocket }, signal) {
    const { [signal.id]: _, ...requestPool } = websocket.requestPool;
    return {
        requestPool,
    };
}
function responseTimeout({ websocket }, signal) {
    const { [signal.id]: _, ...requestPool } = websocket.requestPool;
    return {
        requestPool,
    };
}
function finish({ websocket }, signal) {
    return (0, exports.NotConnected)({
        attempt: 0,
        nextRetry: 0,
        lastPing: 0,
        lastPong: 0,
        uri: "",
        requestId: 0,
        requestPool: {},
        options: websocket.options,
    });
}
//#endregion
//#region States Declarations
exports.NotConnected = exports.WebsocketGroup.registerState("notConnected", {
    ready: () => state_flow_1.Result.reject("invalid state: not connected"),
    connect,
    options,
});
exports.Connecting = exports.WebsocketGroup.registerState("connecting", {
    ready,
    requestSend: requestSendAuth,
    responseReceive,
    responseTimeout,
    error,
    finish,
});
exports.Connected = exports.WebsocketGroup.registerState("connected", {
    networkOffline,
    ping,
    pong,
    finish,
    messageSend,
    requestSend,
    responseReceive,
    responseTimeout,
    internalClose: close,
    error,
});
exports.Suspended = exports.WebsocketGroup.registerState("suspended", {
    ready: () => state_flow_1.Result.reject("invalid state: suspended"),
    networkOnline,
    finish,
    error,
});
exports.Closed = exports.WebsocketGroup.registerState("closed", {
    ready: () => state_flow_1.Result.reject("invalid state: closed"),
    connect,
    connectFailed: closeWithRetry,
    finish,
    error,
});
//#endregion
//# sourceMappingURL=websocket.js.map